import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import {
  RawPercentageInput,
  type RawPercentageInputProps,
} from './RawPercentageInput'

export type PercentageInputProps = RawPercentageInputProps & InputProps

export const PercentageInput = ({
  wrapperProps,
  ...fieldProps
}: PercentageInputProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawPercentageInput {...fieldProps} id={id} />
    </InputWrapper>
  )
}
